const defaultError = {
    name: 'Something went wrong',
    message: 'Please try again or contact support if the problem persists.',
};

export const getError = (error?: Partial<Error>): Error => ({
    name: error?.name ?? defaultError.name,
    message: error?.message ?? defaultError.message,
});
